// Customers List Getters

export const getSystemSettings = state => {
  return state.systemSettings
}

export const getCashierLoginOptions = state => {
  return state.cashierLoginOptions
}

export const getSystemCurrencyOptions = state => {
  return state.systemCurrencyOptions
}

export const getAccountingOptions = state => {
  return state.accountingOptions
}

export const getActiveInactiveOptions = state => {
  return state.activeInactiveOptions
}

export const oldSetSystemSettings = state => {
  return state.systemSettings
}
